/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

export const formQuestionsState = {
    questions: [],
    webpage: null
}; 